import React, { useEffect, useMemo, useState } from "react";
import SearchBar from "../../components/universal/SearchBar";
import SquareCard from "../../components/universal/SquareCard";
import ChannelIcon from "../../assets/icons/navIcons/channelsIcon.svg";
import CustomCarousel from "../../components/universal/CustomCarousel";
import SingleTab from "../../components/universal/SingleTab";
import { AiOutlinePlus, AiOutlineReload } from "react-icons/ai";
import { Link, useNavigate,useLocation } from "react-router-dom";
import ChurchHooks from "./hooks/channelhooks";
import Navbar from "../../components/universal/Navbar";
import { useDispatch } from "react-redux";
import { videosDashboardAction } from "../../store/Layout/LayoutAction";
import {
  readEntityContentAnalyticsRequest,
  readEntityContentViewsAnalyticsRequest,
  readEntityContentViewsTrendingRequest,
} from "../../store/EntityAnalytics/entityAnalyticsActions";
import { readEntityContentAnalytics } from "../../store/EntityAnalytics/entityAnalyticsApi";
import { FaRegArrowAltCircleLeft } from "react-icons/fa";
import ReactECharts from "echarts-for-react";
import DateFilter from "../../components/universal/DateFilter";
import { subDays } from "date-fns";
import { FaDownload } from "react-icons/fa6";
import { downloadExcel } from "../../utils/DownloadExcel";
import { AiOutlineDown } from "react-icons/ai";
import { IoCloseOutline } from "react-icons/io5";
import ChurchModal from "./channelModal";
import { useSelector } from "react-redux";
import { fetchChurchesRequest } from "../../store/Churches/actions";

function Churches() {
  // search bar component state with handler
  const dispatch = useDispatch();
  const { value, onChangeSearchBar } = ChurchHooks();
  // tab clicking state for language table
  const [activeTab, setActiveTab] = useState("Trending");
  const [loading, setLoading] = useState(true);
  const [userTab] = useState("Content");
  const [trendingVideos, setTrendingVideos] = useState([]);
  const [languageTabData, setLanguageTabData] = useState({ xAxis: [], yAxis: [] });
  const [channelOptions, setChannelOptions] = useState([]);
  const [selectedChannelId, setSelectedChannelId] = useState("");
  const [selectedChannelName, setSelectedChannelName] = useState("");


  const [chartData, setChartData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [languageData, setLanguageData] = useState([]);
  const [animate, setAnimate] = useState(false);

  const navigate = useNavigate();


  const onNavigateToAddVideos = () => {
    navigate("/churches/add", { state: { _id: "" } });
  };
  const [isOpen, setIsOpen] = useState(false);
  const [selectedChurch, setSelectedChurch] = useState("Select Church");

  const churches = ["Church 1", "Church 2", "Church 3", "Church 4"];

  const handleSelect = (church) => {
    setSelectedChurch(church);
    setIsOpen(false);
  };
  const [filterRange, setFilterRange] = useState([
    {
      startDate: subDays(new Date(), 7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const fetchReportsData = ({ startDate, endDate }) => {
    setLoading(true);
    const videosPromise = new Promise((resolve, reject) => {
      dispatch(
        videosDashboardAction({
          apiPayloadRequest: {
            startDate: startDate ?? null,
            endDate: endDate ?? null,
          },
          callback: (res) => {
            const data = res?.data ? res?.data : [];
            if (res?.type === 1) {
              setCountryData(
                data?.filter((item) => item.dash === "Country based video Likes")[0]?.data
              );

              setLanguageData(
                data?.filter((item) => item.dash === "Language based video likes")[0]?.data
              );

              // Content breakdown handles the left chart.

              // Entity analytics handles trending/most liked/most watched data.
            }
            resolve();
          },
        })
      );
    });

    Promise.all([videosPromise]).finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchReportsData({
      startDate: filterRange?.[0]?.startDate,
      endDate: filterRange?.[0]?.endDate,
    });
  }, [filterRange]);

  const { contentAnalytics, viewsTrending } = useSelector(
    (state) => state.entityAnalytics || {}
  );
  const contentSummary = contentAnalytics?.summary || {};
  const trendingEntities = viewsTrending?.data?.trendingEntities || [];
  const trendingBuckets = viewsTrending?.data?.trendingBuckets || [];
  const [selectedChannelContentSummary, setSelectedChannelContentSummary] = useState(null);
  const mostViewedEntity = useMemo(() => {
    const entityViewsBucket = Array.isArray(trendingBuckets)
      ? trendingBuckets.find((b) => b?.bucket === "entityViews")
      : null;
    if (entityViewsBucket?.details?.length) {
      return entityViewsBucket.details.reduce((best, current) => {
        const bestViews = Number(best?.views ?? 0);
        const currentViews = Number(current?.views ?? 0);
        return currentViews > bestViews ? current : best;
      }, entityViewsBucket.details[0]);
    }
    if (!Array.isArray(trendingEntities) || trendingEntities.length === 0) return null;
    return trendingEntities.reduce((best, current) => {
      const bestViews = Number(best?.totalViews ?? best?.views?.totalViews ?? 0);
      const currentViews = Number(current?.totalViews ?? current?.views?.totalViews ?? 0);
      return currentViews > bestViews ? current : best;
    }, trendingEntities[0]);
  }, [trendingBuckets, trendingEntities]);
  const mostViewedChannelMatch = channelOptions.find(
    (ch) => ch?._id === mostViewedEntity?.entityObjId
  );
  const mostViewedChannelName =
    mostViewedChannelMatch?.channelName ||
    mostViewedChannelMatch?.churchName ||
    mostViewedEntity?.entityName ||
    "N/A";
  const mostViewedChannelLogo = ChannelIcon;
  const mostViewedChannelViews = Number(
    mostViewedEntity?.views ??
      mostViewedEntity?.totalViews ??
      mostViewedEntity?.views?.totalViews ??
      0
  );

  const contentBreakdown = [
    { label: "Videos", value: Number(contentSummary?.videos || 0) },
    { label: "Curriculums", value: Number(contentSummary?.curriculums || 0) },
    { label: "Plans", value: Number(contentSummary?.plans || 0) },
    { label: "Campuses", value: Number(contentSummary?.campuses || 0) },
    { label: "Carecells", value: Number(contentSummary?.carecells || 0) },
    { label: "Journals", value: Number(contentSummary?.journals || 0) },
    { label: "Members", value: Number(contentSummary?.members || 0) },
    { label: "Programs", value: Number(contentSummary?.programs || 0) },
    { label: "Services", value: Number(contentSummary?.services || 0) },
    { label: "Bulletins", value: Number(contentSummary?.bulletins || 0) },
  ];

  const mapTrendingEntities = (entities = []) =>
    entities.map((item) => ({
      ...item,
      title: item?.entityName,
      likeCount: item?.totalViews || item?.views?.totalViews || 0,
    }));

  useEffect(() => {
    const mapped = mapTrendingEntities(trendingEntities);
    setTrendingVideos(mapped);
  }, [trendingEntities, activeTab]);

  useEffect(() => {
    dispatch(readEntityContentAnalyticsRequest({ typeofentity: "2" }, () => {}));
    dispatch(readEntityContentViewsAnalyticsRequest({ typeofentity: "2" }, () => {}));
    dispatch(
      readEntityContentViewsTrendingRequest({ typeofentity: "2", top: 10 }, () => {})
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      fetchChurchesRequest({ apiPayloadRequest: { typeofentity: "2" } }, (res) => {
        if (res?.type !== 1 || !Array.isArray(res?.data)) return;
        setChannelOptions(res.data);
        if (!selectedChannelId && res.data.length > 0) {
          setSelectedChannelId(res.data[0]._id);
          setSelectedChannelName(res.data[0].channelName || res.data[0].churchName || "");
        }
      })
    );
  }, [dispatch, selectedChannelId]);

  useEffect(() => {
    setChartData({
      xAxis: contentBreakdown.map((item) => item.label),
      yAxis: contentBreakdown.map((item) => ({
        name: item.label,
        value: item.value,
      })),
    });
  }, [
    contentSummary?.videos,
    contentSummary?.curriculums,
    contentSummary?.plans,
    contentSummary?.campuses,
    contentSummary?.carecells,
    contentSummary?.journals,
    contentSummary?.members,
    contentSummary?.programs,
    contentSummary?.services,
    contentSummary?.bulletins,
  ]);

  useEffect(() => {
    if (!selectedChannelId) return;
    let isActive = true;
    (async () => {
      try {
        const res = await readEntityContentAnalytics({
          typeofentity: "2",
          entityObjId: selectedChannelId,
        });
        if (!isActive) return;
        const payload = res || {};
        const summary =
          payload?.summary ||
          (Array.isArray(payload?.data) ? payload.data[0]?.totals : {}) ||
          {};
        setSelectedChannelContentSummary(summary);
      } catch {
        if (isActive) setSelectedChannelContentSummary(null);
      }
    })();
    return () => {
      isActive = false;
    };
  }, [dispatch, selectedChannelId]);

  useEffect(() => {
    if (!selectedChannelContentSummary) return;
    const data = [
      { label: "Videos", value: Number(selectedChannelContentSummary?.videos || 0) },
      {
        label: "Curriculums",
        value: Number(selectedChannelContentSummary?.curriculums || 0),
      },
      { label: "Plans", value: Number(selectedChannelContentSummary?.plans || 0) },
      { label: "Campuses", value: Number(selectedChannelContentSummary?.campuses || 0) },
      { label: "Carecells", value: Number(selectedChannelContentSummary?.carecells || 0) },
      { label: "Journals", value: Number(selectedChannelContentSummary?.journals || 0) },
      { label: "Members", value: Number(selectedChannelContentSummary?.members || 0) },
      { label: "Programs", value: Number(selectedChannelContentSummary?.programs || 0) },
      { label: "Services", value: Number(selectedChannelContentSummary?.services || 0) },
      { label: "Bulletins", value: Number(selectedChannelContentSummary?.bulletins || 0) },
    ];
    setLanguageTabData({
      xAxis: data.map((d) => ({ title: d.label, value: d.value })),
      yAxis: data.map((d) => d.label),
    });
  }, [selectedChannelContentSummary]);
  const [isModalOpen, setIsModalOpen] = useState(false); // ✅ modal state
 const location = useLocation();
   const { userInfo } = useSelector((state) => state.user);
  const hideUI = location.pathname.includes("addfield")|| location.pathname.includes("addChannelField")  ;
  return (
    <>
    <div className="App bg-[#191919] h-fit min-h-screen flex p-4">
    {!hideUI && <Navbar />}

      <div className="flex-1 md:pl-32 md:pt-0 pt-20">
      <div className="flex flex-col gap-4 h-full">

      {!hideUI && <SearchBar placeholder={"Search"} value={value} onChangeSearchBar={onChangeSearchBar} />}

        <div className="flex flex-col gap-4 h-full">
          <div
            className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4 relative"
            id="reportContainer"
          >
            {
                !hideUI&&
            <div className="flex w-full justify-between md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2">
             <div className="flex justify-between items-center flex-1">
                <p className=" text-white text-3xl font-medium flex items-center gap-3">
                  Channels
                  <AiOutlineReload
                    className={`cursor-pointer text-2xl text-yellowish ${
                      loading ? "animate-spin" : ""
                    }`}
                    onClick={() =>
                      fetchReportsData({
                        startDate: filterRange?.[0]?.startDate,
                        endDate: filterRange?.[0]?.endDate,
                      })
                    }
                  />
                </p>
                <p className="flex gap-3 items-center">
                  <DateFilter range={filterRange} setRange={setFilterRange} />
                </p>
              </div>
              <div className="flex gap-4 justify-end">
                <Link to={"/channel/all"} onClick={() => {
                              const church = localStorage.getItem("channel");
                              if (church) {
                                localStorage.removeItem("channel");
                              }
                            }}>
                               <button className=" text-[13px] text-greyish border px-4 py-2 border-greyish bg-blackish rounded-xl">
                                 See All Channels
                               </button>
                             </Link>
                <button
                  // onClick= {()=>setIsModalOpen(true)}
  onClick={() => {
    localStorage.removeItem("channel");
    window.dispatchEvent(new CustomEvent("channel:change", { detail: null }));
    navigate("/addChannelField", { state: { church: null, mode: "create" } });
  }}

                  className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
                >
                  <AiOutlinePlus /> Add Channels
                </button>
                </div>
                </div>
            }

            <div className={`${!hideUI?'flex gap-4 flex-wrap':'grid grid-cols-2 gap-4'}`}>

              <SquareCard
                heading={"No. of Total Channels"}
                icon={ChannelIcon}
                iconStyle={"h-11 w-11"}
                info={contentSummary?.entities || 0}
                downloadIcon={true}
                downloadIconClickHandle={() => {
                  downloadExcel([
                    ...(trendingVideos?.map((d) => ({
                      "Entity Name": d?.title,
                      "Total Views": d?.likeCount,
                    })) ?? []),
                  ]);
                }}
                trail={""}
                percentage={""}
                handleOnClick={() => {
                  setAnimate((prev) => !prev);
                  setActiveTab("Trending");
                }}
              />
              <div
                className="cursor-pointer relative md:w-56 md:h-44 rounded-2xl border border-greyishV2 border-opacity-50 flex flex-col justify-between bg-blackishV2 p-4"
                onClick={() => {
                  if (!mostViewedEntity?.entityObjId) return;
                  const channelPayload = mostViewedChannelMatch || {
                    _id: mostViewedEntity?.entityObjId,
                    channelName: mostViewedChannelName,
                  };
                  navigate("/addChannelField", { state: { church: channelPayload } });
                }}
              >
                <p className="text-sm text-greyish">Most Viewed Channel</p>
                <div className="flex items-center gap-3">
                  <img
                    className="h-11 w-11 object-contain"
                    src={mostViewedChannelLogo}
                    alt=""
                  />
                  <p className="text-white text-sm font-semibold truncate">
                    {mostViewedChannelName}
                  </p>
                </div>
                <div className="flex flex-col gap-1">
                  <p className="text-greyish text-xs">Total Views</p>
                  <p className="text-yellowish text-xl font-bold">
                    {mostViewedChannelViews}
                  </p>
                </div>
              </div>

            </div>
            <div className={`${!hideUI ?'grid grid-rows-1 md:grid-cols-6 grid-cols-1 flex-1 h-full gap-x-4 gap-y-4 my-4':'space-y-4'}`}>

              <div className="md:col-span-3 row-span-1 bg-blackishV2 px-6 py-4 rounded-2xl flex justify-between">
                <div className="text-white w-full">
                  <div className="flex justify-between items-center w-full">
                    <div className="flex items-center gap-8">
                      <p className="text-lg font-semibold text-white">Content Breakdown</p>
                    </div>
                    <div className="md:w-[15vw] w-full">
                      <div className="">
                        <CustomCarousel
                          rows={1}
                          cols={2}
                          gapX={0}
                          gapY={0}
                          // easier to pass this array like this rather than separating it
                          completeSliders={[
                            <SingleTab
                              activeTab={userTab}
                              tab={"Content"}
                              tabClassName="whitespace-nowrap"
                            />,
                          ]}
                          numberOfCardsShownInSingleSlide={3}
                          handleCardOnClick={(card) => {
                            setChartData({
                              xAxis: contentBreakdown.map((item) => item.label),
                              yAxis: contentBreakdown.map((item) => ({
                                name: item.label,
                                value: item.value,
                              })),
                            });
                          }}
                          topNext={"hidden"}
                          topPrev={"hidden"}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="block relative">
                    {chartData?.xAxis?.length > 0 && (
                      <>
                        <button
                          className="text-yellowish absolute top-2 right-2 z-50"
                          onClick={() => {
                            downloadExcel([
                              ...(chartData?.yAxis?.map((d) => ({
                                "Content Type": d?.name,
                                "Total Count": d?.value,
                              })) ?? []),
                            ]);
                          }}
                        >
                          <FaDownload />
                        </button>
                        <ReactECharts
                          className="py-4 bg-blackish mt-5"
                          option={{
                            tooltip: {
                              trigger: "item",
                              axisPointer: {
                                type: "shadow",
                              },
                            },
                            series: [
                              {
                                data: [...chartData?.yAxis],
                                color: ["#EFBC51"],
                                label: {
                                  color: "#fff",
                                },
                                name: userTab,
                                type: "pie",
                                radius: ["40%", "70%"],
                                avoidLabelOverlap: true,
                                padAngle: 5,
                                itemStyle: {
                                  borderRadius: 10,
                                },
                              },
                            ],
                          }}
                          notMerge={true}
                          lazyUpdate={true}
                          theme={"halloween"}
                          onChartReady={() => undefined}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="md:col-span-3 row-span-1 bg-blackishV2 px-6 py-4 rounded-2xl flex flex-col gap-4">
                <div className="flex justify-between md:items-center md:flex-row flex-col gap-4">
                  <div className="flex flex-col">
                    <p className="text-lg font-semibold text-white">Channel Content Breakdown</p>
                    {selectedChannelName && (
                      <p className="text-xs text-greyish mt-1">{selectedChannelName}</p>
                    )}
                  </div>
                  <div className="md:w-[20vw] w-full">
                    <select
                      className="bg-blackish p-2 text-white text-[13px] rounded-md h-10 border border-greyishV2 border-opacity-50 w-full"
                      value={selectedChannelId}
                      onChange={(e) => {
                        const nextId = e.target.value;
                        setSelectedChannelId(nextId);
                        const match = channelOptions.find((c) => c?._id === nextId);
                        setSelectedChannelName(
                          match?.channelName || match?.churchName || ""
                        );
                      }}
                    >
                      {channelOptions.length === 0 && (
                        <option value="">No channels</option>
                      )}
                      {channelOptions.map((ch) => (
                        <option key={ch?._id} value={ch?._id}>
                          {ch?.channelName || ch?.churchName || "Unnamed Channel"}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div
                  className={`${
                    animate
                      ? "absolute bg-blackishV2 w-full h-full left-0  top-0 p-5 rounded-lg z-50 transition-all duration-500 ease-out overflow-y-auto"
                      : "transition-all duration-500 ease-in-out"
                  }`}
                >
                  {animate && (
                    <button
                      className="flex gap-2 font-bold text-xs px-4 py-2 bg-yellowish rounded-md"
                      onClick={() => setAnimate((prev) => !prev)}
                    >
                      <FaRegArrowAltCircleLeft size={16} /> <p>Back</p>
                    </button>
                  )}
                  <div className="w-full h-full relative">
                    <button
                      className="text-yellowish absolute top-2 right-2 z-50"
                      onClick={() => {
                        downloadExcel([
                          ...(languageTabData?.xAxis?.map((d) => ({
                            "Content Type": d?.title,
                            "Total Count": d?.value,
                          })) ?? []),
                        ]);
                      }}
                    >
                      <FaDownload />
                    </button>
                    <ReactECharts
                      key={languageTabData?.yAxis?.length}
                      className="py-4 bg-blackish mt-5"
                      onEvents={{
                        click: (e) => {
                          if (e?.componentType === "series") {
                            navigate("/videos/add", {
                              state: {
                                _id: e?.data?._id || "",
                              },
                            });
                          }
                        },
                      }}
                      option={{
                        resposive: true,
                        // maintainAspectRatio: true,
                        tooltip: {
                          trigger: "axis",
                          axisPointer: {
                            type: "shadow",
                          },
                        },
                        grid: {
                          left: "3%",
                          right: "4%",
                          bottom: "3%",
                          containLabel: true,
                        },
                        yAxis: [
                          {
                            type: "category",
                            data: [...languageTabData?.yAxis],
                            axisLabel: { width: 100, overflow: "truncate" },
                            axisTick: { show: false },
                            // triggerEvent: true,
                          },
                        ],
                        xAxis: [
                          {
                            // triggerEvent: true,
                            type: "value",
                            splitLine: {
                              show: false,
                              lineStyle: {
                                type: "dashed",
                              },
                            },
                          },
                        ],
                        series: [
                          {
                            name: "Content",
                            type: "bar",
                            barWidth: "65%",
                            data: [...languageTabData?.xAxis],
                            color: ["#EFBC51"],
                            itemStyle: {
                              normal: {
                                shadowColor: "rgb(239,188,81, 0.3)",
                                shadowBlur: 15,
                              },
                            },
                          },
                        ],
                        graph: {},
                      }}
                      notMerge={true}
                      lazyUpdate={true}
                      theme={"halloween"}
                      onChartReady={() => undefined}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <ChurchModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}

export default Churches;
